<div class="filter-list">
  <ng-container *ngFor="let filter of appState.companyInfoValue.customPropertyFilterConfig">
    <button
      class="filter-item"
      [ngClass]="{ active: _route.snapshot.queryParamMap.get(filter.key) }"
      (click)="_applyFilter(filter.key)"
    >
      <span class="filter-icon" [style.mask]="_getIconStyle(filter.icon)"></span>
      <span class="filter-label"> {{ filter.name }} </span>
    </button>
  </ng-container>
</div>

<!-- <button class="all-filter-btn" (click)="propertyFilterService.toggleFilterSheet()">
  <span> All Filters </span>
  <span class="filter-bubble"> 7 </span>
  <mat-icon>expand_more</mat-icon>
</button> -->
<div class="provided-main">
  <span class="provided-by" *ngIf="alternateCompanyName">Provided by: </span>
  <span *ngIf="alternateCompanyName" class="company">{{ alternateCompanyName }}</span>
</div>
